import axios from "axios";
import store from "../store";

export default {
  getCustomerAndContracts() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.MARKETING_SERVICE_PUBLIC_PATH}/loss/${store.state.comeback.customerId}/contracts/?g1=${store.state.comeback.uuid1}&g2=${store.state.comeback.uuid2}`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  updateLoss(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data: data,
        url: `${process.env.MARKETING_SERVICE_PUBLIC_PATH}/loss/${store.state.comeback.customerId}/update?g1=${store.state.comeback.uuid1}&g2=${store.state.comeback.uuid2}`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  confirm(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        data: data,
        url: `${process.env.MARKETING_SERVICE_PUBLIC_PATH}/loss/${store.state.comeback.customerId}/confirm?g1=${store.state.comeback.uuid1}&g2=${store.state.comeback.uuid2}`,
      })
          .then(response => resolve(response.data))
          .catch(error => reject(error));
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/marketingService.js